import React from "react";
import { ContentContainer } from "../../../components/layout";
import { Button, Modal, MultiSelect, Select } from "../../../components/core";
import {
	useApolloClient,
	useLazyQuery,
	useMutation,
	useQuery,
} from "@apollo/client";
import {
	ADD_PARTNER_BRANCH_ASSIGNMENT,
	DELETE_PARTNER_BRANCH_ASSIGNMENT,
	GET_PARTNERS_WITH_OR_WITHOUT_ID,
	LOCKER_INFO,
	LOCKER_TYPES,
	PARTNER_ASSIGNMENT_BY_UNASSIGNED_LOCKERS,
	PARTNER_BRANCH_ASSIGNMENT_BY_UNASSIGNED_LOCKERS,
	PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_BRANCHES,
} from "../../../constants/graphql/locker-queries";
import { useDispatch, useSelector } from "react-redux";
import {
	clearSearchData,
	getLockerTypeList,
	getPartnerList,
	getUnassignedBranchList,
	getUnassignedLockerList,
	handleAssignedBranchLockerData,
	handleOnChanged,
} from "../../../features/assign-to-partner/assign-to-partner-slice";

export default function AssignToPartner({ lockerTypeId, lockerId, onSave }) {
	const client = useApolloClient();
	const dispatch = useDispatch();
	const searchData = useSelector((state) => state.assignToPartner.searchData);
	const partnerList = useSelector((state) => state.assignToPartner.partnerList);
	const assignedPartnerLockerData = useSelector(
		(state) => state.assignToPartner.assignedPartnerLockerData
	);
	const unassignedLockerList = useSelector(
		(state) => state.assignToPartner.unassignedLockerList
	);
	const unassignedBranchList = useSelector(
		(state) => state.assignToPartner.unassignedBranchList
	);
	const lockerTypeList = useSelector(
		(state) => state.assignToPartner.lockerTypeList
	);
	// GQL
	const lockerTypes = useQuery(LOCKER_TYPES);
	const partners = useQuery(GET_PARTNERS_WITH_OR_WITHOUT_ID, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
		},
	});
	const [partnerAssignmentByUnassignedLockers] = useLazyQuery(
		PARTNER_ASSIGNMENT_BY_UNASSIGNED_LOCKERS
	);
	const [addPartnerBranchAssignment] = useMutation(
		ADD_PARTNER_BRANCH_ASSIGNMENT
	);
	const partnerAssignmentByUnassignedLockersQuery = useQuery(
		PARTNER_ASSIGNMENT_BY_UNASSIGNED_LOCKERS,
		{ fetchPolicy: "no-cache" }
	);
	const lockerInfo = useQuery(LOCKER_INFO, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: lockerTypeId,
		},
	});
	// Local States
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "Invalid data",
		message: "",
		open: false,
	});
	const [errorValidation, setErrorValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "Invalid data",
		message: "",
		open: false,
	});
	const [searchFlag, setSearchFlag] = React.useState(false);
	const [partnerId, setPartnerId] = React.useState("-1");
	const [lockerList, setLockerList] = React.useState([]);
	React.useEffect(() => {
		if (lockerTypes.data) {
			let tempData = [];
			lockerTypes.data.lockerTypes.forEach((element) => {
				tempData.push({
					value: element.lockerTypeId,
					name: element.lockerType,
				});
			});
			dispatch(getLockerTypeList(tempData));
		}
	}, [lockerTypes.data]);
	React.useEffect(() => {
		if (lockerInfo.data) {
			let tempVar = [];
			lockerInfo.data.lockerInfo.forEach((element) => {
				tempVar.push({
					value: element.lockerId,
					name: element.lockerName,
				});
			});
			setLockerList(tempVar);
		}
	}, [lockerInfo.data]);
	React.useEffect(() => {
		dispatch(clearSearchData());
	}, []);
	const handleOnChange = (event) => {
		const { name, value } = event.target;
		dispatch(handleOnChanged({ name: name, value: value }));
	};
	const handleOnLockerChange = (event) => {
		const { name, value } = event.target;
		// if (unassignedLockerList.find((x) => x.value === lockerId)) {
		//   let tempVar = [];
		//   unassignedLockerList
		//     .find((x) => x.value === lockerId)
		//     .unassignedPartnerBranches.forEach((element) => {
		//       tempVar.push({
		//         value: element.partnerBranchId,
		//         name: element.partnerBranch,
		//       });
		//     });
		//   dispatch(getUnassignedBranchList(tempVar));
		// }
		dispatch(handleAssignedBranchLockerData({ name: name, value: value }));
	};
	const handleOnAddPartnerBranchAssignment = (event) => {
		let tempAssignedPartnerLockerData = { ...assignedPartnerLockerData };
		tempAssignedPartnerLockerData["lockerId"] = lockerId;
		console.log(tempAssignedPartnerLockerData);
		if (
			partnerId === "-1" ||
			partnerId === -1 ||
			tempAssignedPartnerLockerData.partnerBranchId === "-1" ||
			tempAssignedPartnerLockerData.partnerBranchId === -1
		) {
			console.log(partnerId);
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Empty fields error",
				message: "You must select Partner and Branch.",
				open: true,
			});
		}
		addPartnerBranchAssignment({
			variables: tempAssignedPartnerLockerData,
		})
			.then((data) => {
				// console.log(data.data);
				dispatch(getUnassignedLockerList([]));
				partnerAssignmentByUnassignedLockersQuery
					.refetch(searchData)
					.then((data) => {
						if (data.data.partnerAssignmentsByUnassignedLockers) {
							let tempVar = [];
							data.data.partnerAssignmentsByUnassignedLockers.forEach(
								(element) => {
									tempVar.push({
										value: element.lockerId,
										name: element.lockerName,
										unassignedPartnerBranches:
											element.unassignedPartnerBranches,
									});
								}
							);
							dispatch(getUnassignedLockerList(tempVar));
							dispatch(getUnassignedLockerList(tempVar));
							dispatch(getUnassignedBranchList([]));
							dispatch(
								handleAssignedBranchLockerData({
									name: "unassignedLocker",
									value: "-1",
								})
							);
							dispatch(
								handleAssignedBranchLockerData({
									name: "partnerBranchId",
									value: "-1",
								})
							);
							onSave();
							// setValidation({
							//   icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
							//   title: "Successfully assigned locker to a branch.",
							//   message: "",
							//   open: true,
							// });
						}
					});
			})
			.catch((e) => console.log(e));
		// client.clearStore();
	};
	React.useEffect(() => {
		if (unassignedLockerList.find((x) => x.value === lockerId)) {
			let tempVar = [];
			unassignedLockerList
				.find((x) => x.value === lockerId)
				.unassignedPartnerBranches.forEach((element) => {
					tempVar.push({
						value: element.partnerBranchId,
						name: element.partnerBranch,
					});
				});
			dispatch(getUnassignedBranchList(tempVar));
		}
	}, [unassignedLockerList.find((x) => x.value === lockerId)]);
	React.useEffect(() => {
		let tempSearchData = { ...searchData };
		tempSearchData["lockerTypeId"] = lockerTypeId;
		tempSearchData["partnerId"] = partnerId;
		if (
			tempSearchData.lockerTypeId !== "-1" &&
			tempSearchData.partnerId !== "-1"
		) {
			setSearchFlag(true);
			partnerAssignmentByUnassignedLockers({ variables: tempSearchData }).then(
				(data) => {
					if (data.data.partnerAssignmentsByUnassignedLockers) {
						let tempVar = [];
						data.data.partnerAssignmentsByUnassignedLockers.forEach(
							(element) => {
								tempVar.push({
									value: element.lockerId,
									name: element.lockerName,
									unassignedPartnerBranches: element.unassignedPartnerBranches,
								});
							}
						);
						dispatch(getUnassignedLockerList(tempVar));
					}
				}
			);
		}
	}, [lockerTypeId]);
	React.useEffect(() => {
		console.log(unassignedBranchList);
	}, [unassignedBranchList]);
	React.useEffect(() => {
		let tempSearchData = { ...searchData };
		tempSearchData["partnerId"] = partnerId;
		tempSearchData["lockerTypeId"] = lockerTypeId;
		console.log(tempSearchData);
		if (
			tempSearchData.partnerId !== "-1" &&
			tempSearchData.lockerTypeId !== "-1"
		) {
			setSearchFlag(true);
			partnerAssignmentByUnassignedLockers({ variables: tempSearchData }).then(
				(data) => {
					if (data.data.partnerAssignmentsByUnassignedLockers) {
						let tempVar = [];
						data.data.partnerAssignmentsByUnassignedLockers.forEach(
							(element) => {
								tempVar.push({
									value: element.lockerId,
									name: element.lockerName,
									unassignedPartnerBranches: element.unassignedPartnerBranches,
								});
							}
						);
						dispatch(getUnassignedLockerList(tempVar));
					}
				}
			);
		}
	}, [partnerId]);
	React.useEffect(() => {
		if (partners.data) {
			let tempVar = [];
			partners.data.partners.forEach((element) => {
				tempVar.push({
					value: element.partnerId,
					name: element.companyNickname,
				});
			});
			dispatch(getPartnerList(tempVar));
		}
	}, [partners.data]);
	return (
		<ContentContainer>
			<div className="grid grid-cols-5 gap-2">
				<div className="col-span-2">
					<p className="text-base my-auto">Locker Type: </p>
				</div>
				{/* <div className="bg-slate-50 col-span-3"> */}
				<p className="col-span-3 text-start my-auto font-bold">
					{lockerTypeList.find((x) => x.value === lockerTypeId) &&
						lockerTypeList.find((x) => x.value === lockerTypeId).name}
				</p>
				{/* <div className="col-span-1"></div> */}
				<div className="col-span-2">
					<p className="text-base my-auto">
						<b>
							{lockerTypeList.find(
								(x) => parseInt(x.value) === parseInt(lockerTypeId)
							) &&
								lockerTypeList.find(
									(x) => parseInt(x.value) === parseInt(lockerTypeId)
								).name}
						</b>{" "}
						Locker:
					</p>
				</div>
				<p className="col-span-3 text-start my-auto font-bold">
					{lockerList.find((x) => x.value === lockerId) &&
						lockerList.find((x) => x.value === lockerId).name}
				</p>
				{/* <div className="bg-slate-50 col-span-3">
          
          <Select
            items={unassignedLockerList}
            value={assignedPartnerLockerData.lockerId}
            defaultOption={{ value: "-1", name: "-- Select a Locker --" }}
            name="unassignedLocker"
            onChange={handleOnLockerChange}
          />
        </div> */}
				{/* <div className="col-span-1"></div> */}
				<div className="col-span-2">
					<p className="text-base mt-2">Partner:</p>
				</div>
				<div className="bg-slate-50 col-span-3">
					<Select
						value={partnerId}
						items={partnerList}
						defaultOption={{ value: "-1", name: "-- Select a partner --" }}
						onChange={(e) => {
							setPartnerId(e.target.value);
							dispatch(getUnassignedBranchList([]));
						}}
						name="partnerBranchId"
					/>
				</div>
				<div className="col-span-2">
					<p className="text-base mt-2">
						<b>
							{partnerList.find((x) => x.value === searchData.partnerId) &&
								partnerList.find((x) => x.value === searchData.partnerId).name}
						</b>{" "}
						Branch
					</p>
				</div>
				<div className="bg-slate-50 col-span-3">
					<Select
						disabled={unassignedBranchList.length == 0}
						value={partnerId === "-1" ? "-1" : assignedPartnerLockerData.partnerBranchId}
						items={partnerId === "-1" ? [] : unassignedBranchList}
						defaultOption={{ value: "-1", name: "-- Select a Branch --" }}
						onChange={handleOnLockerChange}
						name="partnerBranchId"
					/>
				</div>
				<div className="col-span-1"></div>
				<div className="col-span-1"></div>
				<div className="col-span-1 flex">
					<Button
						onClick={handleOnAddPartnerBranchAssignment}
						className={"w-full h-full mr-2 p-2"}
						value="Assign Locker"
					/>
				</div>
			</div>
			<p className={`text-red-500 ${validation.open ? "" : "hidden"}`}>
				Please select Partner and Branch.
			</p>
			{/* {searchFlag && (
        <div className="grid grid-cols-5 gap-2">
          <div className="col-span-1">
            <p className="text-base mt-2">
              Select{" "}
              <b>
                {lockerTypeList.find(
                  (x) => parseInt(x.value) === parseInt(searchData.lockerTypeId)
                ) &&
                  lockerTypeList.find(
                    (x) =>
                      parseInt(x.value) === parseInt(searchData.lockerTypeId)
                  ).name}
              </b>{" "}
              Locker:
            </p>
          </div>
          <div className="bg-slate-50 col-span-3">
            <Select
              items={unassignedLockerList}
              value={assignedPartnerLockerData.lockerId}
              defaultOption={{ value: "-1", name: "-- Select a Locker --" }}
              name="unassignedLocker"
              onChange={handleOnLockerChange}
            />
          </div>
          <div className="col-span-1"></div>
          <div className="col-span-1">
            <p className="text-base mt-2">
              Assign to{" "}
              <b>
                {partnerList.find((x) => x.value === searchData.partnerId) &&
                  partnerList.find((x) => x.value === searchData.partnerId)
                    .name}
              </b>{" "}
              Branch
            </p>
          </div>
          <div className="bg-slate-50 col-span-3">
            <Select
              value={assignedPartnerLockerData.partnerBranchId}
              items={unassignedBranchList}
              defaultOption={{ value: "-1", name: "-- Select a Branch --" }}
              onChange={handleOnLockerChange}
              name="partnerBranchId"
            />
          </div>
          <div className="col-span-1"></div>
          <div className="col-span-1"></div>
          <div className="col-span-1 flex">
            <Button
              onClick={handleOnAddPartnerBranchAssignment}
              className={"w-full h-full mr-2 p-2"}
              value="Assign Locker"
            />
          </div>
        </div>
      )} */}
			{/* Modal for removing confirmation */}
			{/* <Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={
					<div className="grid grid-cols-1 gap-2">
						<Button
							onClick={() => {
								setValidation((prev) => ({
									...prev,
									open: false,
								}));
							}}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				}
			/> */}
			<Modal
				icon={errorValidation.icon}
				title={errorValidation.title}
				message={errorValidation.message}
				open={errorValidation.open}
				actions={
					<div className="grid grid-cols-1 gap-2">
						<Button
							onClick={() => {
								setErrorValidation((prev) => ({
									...prev,
									open: false,
								}));
							}}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				}
			/>
		</ContentContainer>
	);
}
